import Datapolicy from './DataPolicy.json';
import MusePlans from './MusePlans.json';
import MuseTrialPlans from './MuseTrialPlans.json';
import MuseAndroidPromo from './MuseAndroidPromo.json';
import SubscriptionActivate from './SubscriptionActivate.json';
import CheckoutSuccess from './CheckoutSuccess.json';
import SubscriptionActivateSuccess from './SubscriptionActivateSuccess.json';
import Account from './Account.json';
import Subscriptions from './Subscriptions.json';
import HeaderAndSidebarLayout from './HeaderAndSidebarLayout.json';
import HeaderLayout from './HeaderLayout.json';
import MsPlans from './MsPlans.json';
import ActivatePartner from './ActivatePartner.json';
import ActivatePartnerSuccess from './ActivatePartnerSuccess.json';
import CheckoutSuccessMeditationStudio from './CheckoutSuccessMeditationStudio.json';
import DirectAndroidPlans from './DirectAndroidPlans.json';
import DirectWindowsPlans from './DirectWindowsPlans.json';

export default {
  ...Datapolicy,
  ...MusePlans,
  ...MuseTrialPlans,
  ...MuseAndroidPromo,
  ...CheckoutSuccess,
  ...SubscriptionActivate,
  ...SubscriptionActivateSuccess,
  ...Account,
  ...Subscriptions,
  ...HeaderAndSidebarLayout,
  ...HeaderLayout,
  ...MsPlans,
  ...ActivatePartner,
  ...ActivatePartnerSuccess,
  ...CheckoutSuccessMeditationStudio,
  ...DirectAndroidPlans,
  ...DirectWindowsPlans
};



// WEBPACK FOOTER //
// ./src/i18n/fr/views/index.js